import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Icons } from '@app/enums/icons.enum';

@Injectable({ providedIn: 'root' })
export class IconsService {
    private readonly matIconRegistry = inject(MatIconRegistry);
    private readonly domSanitizer = inject(DomSanitizer);

    constructor() {
        this.registerIcons();
    }

    public registerIcons(): void {
        this.loadIcons(
            Object.keys(Icons).map((x) => Icons[x]),
            '../assets/icons'
        );
    }

    private loadIcons(iconKeys: string[], iconUrl: string): void {
        iconKeys.forEach((key) => {
            this.matIconRegistry.addSvgIcon(
                key,
                this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconUrl}/${key}.svg`)
            );
        });
    }
}
